import { registerSW } from 'virtual:pwa-register';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { t } from '@/shared/i18n/t';

/** Register the service worker; offer the new version when one is waiting. */
export function usePwaUpdates(): void {
  useEffect(function register() {
    const update = registerSW({
      onNeedRefresh() {
        toast(t('A new version is available'), {
          duration: Number.POSITIVE_INFINITY,
          action: { label: t('Update'), onClick: () => void update(true) },
        });
      },
      onOfflineReady() {
        toast.success(t('Ready to use offline'));
      },
    });
  }, []);
}
